export default __webpack_public_path__ + "static/media/mad-ape-008.bdce8bae.svg";